import React from 'react';
import { Rectangle } from 'recharts';

function QuoteChartTooltipCursor(props: any) {
  const {
    payload,
    pointerEvents,
    height,
    points,
    className,
    isVisibleRealTradeTypeChart,
  } = props;
  const { x, y } = points[0];

  if (payload.length > 1) {
    const { woodaebbangPrice, price } = payload[0].payload;
    const isNullNotVisibleRealTradePrice =
      !isVisibleRealTradeTypeChart && !woodaebbangPrice;
    const isNullVisibleRealTradePrice =
      isVisibleRealTradeTypeChart && !woodaebbangPrice && !price;
    if (isNullNotVisibleRealTradePrice) return null;
    if (isNullVisibleRealTradePrice) return null;
    return (
      <Rectangle
        fill="transparent"
        stroke="#D1E1FF"
        strokeWidth={1}
        x={x}
        y={y}
        width={1}
        height={height}
        fillOpacity={0}
        pointerEvents={pointerEvents}
        points={points}
        className={className}
        type="linear"
      />
    );
  }

  return null;
}

export default QuoteChartTooltipCursor;
